import { FullcalendarComponent } from './Componenti/fullcalendar/fullcalendar.component';
import { MappaComponent } from './mappa/mappa.component';
import { GroupVerticalBarChartComponent } from './Componenti/group-vertical-bar-chart/group-vertical-bar-chart.component';
import { PieComponent } from './Componenti/pie/pie.component';
import { DashboardComponent } from './Dashboard/Dashboard.component';
import { AngularFileUploaderModule } from './file-uploader/angular-file-uploader.module';
import { FilePerTipo, FileUploaderComponent } from './file-uploader/file-uploader.component';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { Camera, Heart, Github, Activity, Airplay, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeftCircle, ArrowLeft, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, AtSign, Award, BarChart2, BarChart, BatteryCharging, Battery, BellOff, Bell, Bluetooth, Bold, BookOpen, Book, Bookmark, Box, Briefcase, Calendar, CameraOff, Cast, CheckCircle, CheckSquare, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, Chrome, Circle, Clipboard, Clock, CloudDrizzle, CloudLightning, CloudOff, CloudRain, Cloud, CloudSnow, Code, Codepen, Codesandbox, Coffee, Columns, Command, Compass, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Crosshair, Database, Delete, Disc, DollarSign, DownloadCloud, Download, Droplet, Edit, Edit2, Edit3, ExternalLink, EyeOff, Eye, Facebook, FastForward, Feather, Figma, FileMinus, FilePlus, FileText, File, Film, Filter, Flag, Folder, FolderMinus, FolderPlus, Framer, Frown, Gift, GitBranch, GitCommit, GitMerge, GitPullRequest, Gitlab, Globe, Grid, HardDrive, Hash, Headphones, HelpCircle, Hexagon, Home, MoreHorizontal, Image, Inbox, Info, Instagram, Italic, Key, Layers, Layout, LifeBuoy, Link, Link2, Linkedin, List, Loader, Lock, LogIn, LogOut, Mail, MapPin, Map, Maximize, Maximize2, Meh, Menu, MessageCircle, MessageSquare, Mic, MicOff, Minimize, Minimize2, MinusCircle, MinusSquare, Minus, Monitor, Moon, MoreVertical, MousePointer, Move, Music, Navigation, Navigation2, Octagon, Package, Paperclip, PauseCircle, Pause, PenTool, Percent, PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, Phone, PhoneOff, PhoneOutgoing, PieChart, Play, PlayCircle, Plus, PlusCircle, PlusSquare, Pocket, Power, Printer, Radio, RefreshCcw, RefreshCw, Repeat, Rewind, RotateCcw, RotateCw, Rss, Save, Scissors, Search, Send, Server, Settings, Share, Share2, Shield, ShieldOff, ShoppingBag, ShoppingCart, Shuffle, Sidebar, SkipBack, SkipForward, Slack, Slash, Sliders, Smartphone, Smile, Speaker, Square, Star, StopCircle, Sun, Sunrise, Sunset, Tablet, Tag, Target, Terminal, Thermometer, ThumbsDown, ThumbsUp, ToggleLeft, ToggleRight, Tool, Trash, Trash2, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Twitch, Twitter, Type, Umbrella, Underline, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Users, Video, VideoOff, Voicemail, Volume, Volume1, Volume2, VolumeX, Watch, Wifi, WifiOff, Wind, XCircle, XOctagon, XSquare, X, Youtube, Zap, ZapOff, ZoomIn, ZoomOut } from 'angular-feather/icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AgmCoreModule } from '../../LibrerieCustom/agm-core-1.1.0/core.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { StampeModule } from "../Stampe/Stampe.module";
import { TranslateModule } from "@ngx-translate/core";
import { LineChart_Component } from "./Componenti/Line_Chart/Line-Chart.component";
import { NgChartsModule } from "ng2-charts";
import { ImportComponentComponent } from './import-component/import-component.component';
import { TranslatedDescComponent } from "./translated-desc/translated-desc.component";
import { ListFilterPipe, NgMultiSelectDropDownModule } from "../../LibrerieCustom/MultiselectDropdown";
import { FieldViewerComponent } from './field-viewer/field-viewer.component';
import { SectorViewerComponent } from './sector-viewer/sector-viewer.component';
import { CheckboxArrayViewerComponent } from './checkbox-array-viewer/checkbox-array-viewer.component';
import { AngularEditorModule } from "../../LibrerieCustom/angular-editor/src/public-api";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { PartecipantiListComponent, PipePartecipanti } from "./partecipanti-list/partecipanti-list.component";
import { ListCampiViewerComponent } from "./List-campi-viewer/list-campi-viewer.component";
import { DynamicDashboardComponent } from './dynamic-dashboard/dynamic-dashboard.component';
import { AutoFocusSharedDirective, SharedTempiListComponent } from "./tempi-list/tempi-list.component";
import { QuestionarioComponent } from "./Checklists/Questionario/questionario.component";
import { CheckCategoriesComponent } from "./Checklists/check-categories/check-categories.component";
import { CheckListComponent } from "./Checklists/check-list/check-list.component";
import { FileListComponent } from './file-list/file-list.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { CheckListValutazioneComponent } from './Checklists/check-list-valutazione/check-list-valutazione.component';
import { RipetizioneTaskComponent } from './ripetizione-task/ripetizione-task.component';
import { CheckPerDataComponent } from './Checklists/check-per-data/check-per-data.component';
import { CategorieNavSelectComponent } from './categorieNavSelect/categorie-nav-select.component';
import { LegendaComponent } from "./legenda/legenda.component";
import { DynamicColTable } from './DynamicColTable/DynamicColTable.component';
import { CategorieNavComponent } from './CategorieNav/categorie-nav.component';
import { CategorieListComponent, CatListPipe } from './CategorieList/categorie-list.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { DynamicListComponent } from './dynamic-list/dynamic-list.component';
import { DynamicListRowComponent } from './dynamic-list-row/dynamic-list-row.component';
import { DynamicEditComponent } from './dynamic-edit/dynamic-edit.component';
import { DynamicTabsComponent, ShowTabPipe } from './dynamic-tabs/dynamic-tabs.component';
import { DynamicButtonsComponent } from './dynamic-buttons/dynamic-buttons.component';
import { LISTComponent } from '../task/list/list.component';
import { Alert } from './Alerts/Alert.component';
import { NotificationsComponent } from './Notifications/notifications.component';
import { TooltipIcon } from './Tooltip-Icon/Tooltip-Icon.component';
import { autocompleteInputComponent, AutoCopleteListPipe } from './Componenti/AutoCompleteTextInput/AutocompleteInput.component'
import { CardMenuComponent } from './card-menu/card-menu.component';
import { RegistroPresenzeComponent } from '../Admin/registro-presenze/registro-presenze.component';
import { PipeReferenti, ReferentiComponent } from '../Admin/component/referenti/referenti.component';
import { ImagesListComponent } from './images-list/images-list.component';
import { DynamicPlanComponent } from './dynamic-plan/dynamic-plan.component';
import {CalendarFieldComponent} from "./field-viewer/calendar-field";
import {ImageCarouselComponent} from "./Componenti/ImageCarousel/ImageCarouselComponent"
// Select some icons (use an object, not an array)
const icons = {
  Camera, Heart, Github, Activity, Airplay, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeftCircle, ArrowLeft, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, AtSign, Award, BarChart2, BarChart, BatteryCharging, Battery, BellOff, Bell, Bluetooth, Bold, BookOpen, Book, Bookmark, Box, Briefcase, Calendar, CameraOff, Cast, CheckCircle, CheckSquare, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, Chrome, Circle, Clipboard, Clock, CloudDrizzle, CloudLightning, CloudOff, CloudRain, Cloud, CloudSnow, Code, Codepen, Codesandbox, Coffee, Columns, Command, Compass, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Crosshair, Database, Delete, Disc, DollarSign, DownloadCloud, Download, Droplet, Edit, Edit2, Edit3, ExternalLink, EyeOff, Eye, Facebook, FastForward, Feather, Figma, FileMinus, FilePlus, FileText, File, Film, Filter, Flag, Folder, FolderMinus, FolderPlus, Framer, Frown, Gift, GitBranch, GitCommit, GitMerge, GitPullRequest, Gitlab, Globe, Grid, HardDrive, Hash, Headphones, HelpCircle, Hexagon, Home, MoreHorizontal, Image, Inbox, Info, Instagram, Italic, Key, Layers, Layout, LifeBuoy, Link, Link2, Linkedin, List, Loader, Lock, LogIn, LogOut, Mail, MapPin, Map, Maximize, Maximize2, Meh, Menu, MessageCircle, MessageSquare, Mic, MicOff, Minimize, Minimize2, MinusCircle, MinusSquare, Minus, Monitor, Moon, MoreVertical, MousePointer, Move, Music, Navigation, Navigation2, Octagon, Package, Paperclip, PauseCircle, Pause, PenTool, Percent, PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, Phone, PhoneOff, PhoneOutgoing, PieChart, Play, PlayCircle, Plus, PlusCircle, PlusSquare, Pocket, Power, Printer, Radio, RefreshCcw, RefreshCw, Repeat, Rewind, RotateCcw, RotateCw, Rss, Save, Scissors, Search, Send, Server, Settings, Share, Share2, Shield, ShieldOff, ShoppingBag, ShoppingCart, Shuffle, Sidebar, SkipBack, SkipForward, Slack, Slash, Sliders, Smartphone, Smile, Speaker, Square, Star, StopCircle, Sun, Sunrise, Sunset, Tablet, Tag, Target, Terminal, Thermometer, ThumbsDown, ThumbsUp, ToggleLeft, ToggleRight, Tool, Trash, Trash2, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Twitch, Twitter, Type, Umbrella, Underline, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Users, Video, VideoOff, Voicemail, Volume, Volume1, Volume2, VolumeX, Watch, Wifi, WifiOff, Wind, XCircle, XOctagon, XSquare, X, Youtube, Zap, ZapOff, ZoomIn, ZoomOut
};
const routes: Routes = [
  {
    path: 'dashboard',
    data: {
      title: "Dashboard",
      urls: [{ title: "Dashboard", url: "/dashboard" }],
    },
    component: DashboardComponent,
  },
  {
    path: 'dynamic',
    data: {
      title: "Dashboard",
      urls: [{ title: "Dashboard" }],
    },
    component: DynamicDashboardComponent,
  },
  {
    path: 'cruscotto',
    data: {
      title: "Dashboard",
      urls: [{ title: "Dashboard" }],
    },
    component: DynamicDashboardComponent,
  },
  {
    path: 'files',
    data: {
      title: "Files",
      urls: [{ title: "Lista" }],
    },
    component: FileListComponent,
  },
  {
    path: 'under-construction',
    data: {
      title: "Under Construction",
      urls: [{ title: "Under Construction" }],
    },
    component: UnderConstructionComponent,
  },
  {
    path: 'ripetizione',
    data: {
      title: "",
      urls: [{ title: "" }],
    },
    component: CategorieNavSelectComponent,
  },
  {
    path: 'checkdata',
    data: {
      title: "",
      urls: [{ title: "" }],
    },
    component: CheckPerDataComponent,
  },
  {
    path: 'test',
    data: {
      title: "",
      urls: [{ title: "" }],
    },
    component: DynamicColTable
  },
  {
    path: 'categorie',
    data: {
      title: "Settings Categorie",
      urls: [{ title: "" }],
    },
    component: CategorieListComponent
  },
  {
    path: 'categorie/:type',
    data: {
      title: "Settings Categorie",
      urls: [{ title: "" }],
    },
    component: CategorieListComponent
  },
  {
    path: 'dynamiclist/:type',
    data: {
      title: "List",
      urls: [{ title: "" }],
    },
    component: DynamicListComponent
  },
  {
    path: 'dynamicedit/:type/:id',
    data: {
      title: "Edit",
      urls: [{ title: "" }],
    },
    component: DynamicEditComponent
  },
  {
    path: 'dynamicedit/:type',
    data: {
      title: "Edit",
      urls: [{ title: "" }],
    },
    component: DynamicEditComponent
  },
  {
    path: 'cardmenu',
    data: {
      title: "List",
      urls: [{ title: "" }],
    },
    component: CardMenuComponent
  },
  {
    path: 'dynamicplan',
    data: {
      title: "Mappe",
      urls: [{ title: "" }],
    },
    component: DynamicPlanComponent
  }
];

@NgModule({

  imports: [
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAtHf7gRjLvTbRzwUy4GQ-87hNa--almW0'
    }),
    AngularFileUploaderModule,
    FeatherModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SignaturePadModule,
    NgxChartsModule,
    FeatherModule.pick(icons),
    RouterModule.forChild(routes),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    StampeModule,
    TranslateModule,
    NgChartsModule,
    NgMultiSelectDropDownModule,
    AngularEditorModule,
    PdfViewerModule,
    NgbModalModule,

  ],
  declarations: [
    FileUploaderComponent,
    autocompleteInputComponent,
    DashboardComponent,
    PieComponent,
    GroupVerticalBarChartComponent,
    MappaComponent,
    FullcalendarComponent,
    LineChart_Component,
    ImportComponentComponent,
    TranslatedDescComponent,
    FieldViewerComponent,
    SectorViewerComponent,
    RegistroPresenzeComponent,
    CheckboxArrayViewerComponent,
    PartecipantiListComponent,
    ListCampiViewerComponent,
    DynamicDashboardComponent,
    SharedTempiListComponent,
    AutoFocusSharedDirective,
    QuestionarioComponent,
    CheckCategoriesComponent,
    CheckListComponent,
    FilePerTipo,
    FileListComponent,
    RipetizioneTaskComponent,
    CheckListValutazioneComponent,
    UnderConstructionComponent,
    CheckPerDataComponent,
    CategorieNavSelectComponent,
    LegendaComponent,
    DynamicColTable,
    CategorieNavComponent,
    CatListPipe,
    CategorieListComponent,
    DynamicListComponent,
    DynamicListRowComponent,
    DynamicEditComponent,
    DynamicTabsComponent,
    ShowTabPipe,
    DynamicButtonsComponent,
    LISTComponent,
    Alert,
    TooltipIcon,
    NotificationsComponent,
    AutoCopleteListPipe,
    CardMenuComponent,
    ReferentiComponent,
    PipeReferenti,
    PipePartecipanti,
    ImagesListComponent,
    DynamicPlanComponent,
    CalendarFieldComponent,
    ImageCarouselComponent
  ],
    exports: [
        FullcalendarComponent,
        FileUploaderComponent,
        AngularFileUploaderModule,
        MappaComponent,
        ImportComponentComponent,
        TranslatedDescComponent,
        FieldViewerComponent,
        SectorViewerComponent,
        ListCampiViewerComponent,
        PartecipantiListComponent,
        SharedTempiListComponent,
        QuestionarioComponent,
        CheckCategoriesComponent,
        FilePerTipo,
        CheckPerDataComponent,
        LegendaComponent,
        DynamicColTable,
        CategorieNavComponent,
        DynamicTabsComponent,
        ShowTabPipe,
        CheckListComponent,
        DynamicButtonsComponent,
        LISTComponent,
        NotificationsComponent,
        AutoCopleteListPipe,
        autocompleteInputComponent,
        RegistroPresenzeComponent,
        ReferentiComponent,
        PipeReferenti,
        PipePartecipanti,
        DynamicListComponent,
        ImagesListComponent,
        TooltipIcon,
      CalendarFieldComponent

    ]
})
export class SharedModule {
}
